import { useState } from 'react';
import { useActiveDrivers } from '../hooks';
import { LoaderBackdrop, ToggleSwitch } from '@/components';
import DriverMonitoringError from './DriverMonitoringError';
import DriverMonitoringEmpty from './DriverMonitoringEmpty';
import DriverMonitoringWarning from './DriverMonitoringWarning';
import DriverMonitoringGrid from './DriverMonitoringGrid';

const DriverMonitoringView = () => {
  const { activeDrivers, isLoading, error } = useActiveDrivers();
  const [filterActiveRoute, setFilterActiveRoute] = useState(false);

  const filteredDrivers = filterActiveRoute
    ? activeDrivers.filter((d) => d.isInActiveRoute)
    : activeDrivers;

  const driversToShow = filteredDrivers.slice(0, 10);
  const hasMoreDrivers = filteredDrivers.length > 10;

  const renderContent = () => {
    if (isLoading) return <LoaderBackdrop />;
    if (error) return <DriverMonitoringError />;
    if (driversToShow.length === 0) return <DriverMonitoringEmpty />;
    return (
      <>
        {hasMoreDrivers && (
          <DriverMonitoringWarning totalCount={filteredDrivers.length} />
        )}
        <DriverMonitoringGrid drivers={driversToShow} />
      </>
    );
  };

  return (
    <div className='flex flex-col w-full h-full gap-4'>
      <div className='flex items-center gap-3 px-4 py-2 bg-white border border-gray-200 rounded-lg mx-4'>
        <ToggleSwitch
          checked={filterActiveRoute}
          onChange={setFilterActiveRoute}
          ariaLabel='Filtrar por ruta activa'
        />
        <div className='flex flex-col'>
          <span className='text-sm font-medium text-gray-800'>En ruta activa</span>
          <span className='text-xs text-gray-500'>
            {filterActiveRoute
              ? `Mostrando conductores en ruta activa`
              : 'Mostrando todos los conductores'}
          </span>
        </div>
      </div>
      {renderContent()}
    </div>
  );
};

export default DriverMonitoringView;
